import type { BuiltinIntegrationSpec } from '@repo/common/interfaces/integrationSpec';
import { memo } from 'react';
import { BuiltinIntegrationSpecCard } from '../../../components/IntegrationSpecCard/BuiltinIntegrationSpecCard';

export const IntegrationButton = memo(
	({
		integration,
		...props
	}: {
		integration: BuiltinIntegrationSpec;
		onClick: () => void;
	}) => (
		<BuiltinIntegrationSpecCard spec={integration} onClick={props.onClick} />
	)
);
